<template>
    <div class="accordion" :class="{ 'is-closed' : isClosed }">

        <h3 class=accordion-title @click="toggleOpen">{{ accordionTitle }}</h3>

        <div ref="accordionContent"
             class=accordion-content
             v-html="accordionContent"
             :style="{ height : accordionHeight }"
        ></div>

    </div>
</template>
<script>
export default {
    name : 'accordion',
    props : {
        accordionTitle   : String,
        accordionContent : String,
    },
    data() {
        return {
            isClosed      : true,
            currentHeight : 0   ,
        }
    },
    methods : {
        toggleOpen() {
            this.isClosed = !this.isClosed;

            if( !this.isClosed ) {
                this.currentHeight = this.$refs.accordionContent.scrollHeight;
            }
            else {
                this.currentHeight = 0;
            }

        }
    },
    computed : {
        accordionHeight() {
            return this.currentHeight + 'px';
        }
    }
}
</script>